import { Component, OnInit } from '@angular/core';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { ReportsTurnsService } from 'src/app/services/turns-services/reports-turns-service/reports-turns.service';
import { DashboardService } from 'src/app/services/dashboard-services/dashboard.service';
import { tap } from 'rxjs/internal/operators/tap';
import { Subscription } from 'rxjs/internal/Subscription';
import { formatDate } from '@angular/common';
import * as moment from 'moment';

@Component({
  selector: 'app-dashboard-sales',
  templateUrl: './dashboard-sales.component.html',
  styleUrls: ['./dashboard-sales.component.scss']
})
export class DashboardSalesComponent implements OnInit {

  centers;
  selectedCenters;
  from;
  to;

  topSales;
  totalSales;
  totalValue;
  averageSales = '0';
  noItemsConfig;

  colors = [
    '#3bafda',
    '#ed5565',
    '#fcbb42',
    '#37bc9b',
    '#967adc',
    '#d770ad',
    '#ff9d00',
    '#75560d',
    '#ffe4b5',
    '#eeeeee',
    '#6d7182',
  ];

  dashboardServiceSubscription: Subscription;

  constructor(
    private userStorageService: UserStorageService,
    private reportsTurnsService: ReportsTurnsService,
    private dashboardService: DashboardService,
    private headerBreadcrumbService: HeaderBreadcrumbService) {
      this.centers = this.userStorageService.getCenterList();
      this.noItemsConfig = this.setNoItemsConfig();
    }

  ngOnInit() {
    this.setBreadcrumb();
    this.selectedCenters = [this.centers[0]];
    this.dashboardServiceSubscription = this.dashboardService.listenReloadStatistics().pipe(
      tap(o => this.selectedCenters = o['centers']),
      tap(o => this.from = o['from'].valueOf()),
      tap(o => this.to = o['to'].valueOf()),
      tap(o => this.loadData())
    ).subscribe();
  }

  private loadData() {
    this.topSales = null;
    this.getSalesByCenter();
  }

  private getSalesByCenter() {
    const auth = 'PqT5xMercadoPruebasBjVGyBB';
    const fechaIni = moment(this.from).format('YYYY-MM-DD');
    const fechaFin = moment(this.to).format('YYYY-MM-DD');
    this.reportsTurnsService.getSalesByCenter(fechaIni, fechaFin, auth).pipe(
      tap((datos) => {
        console.log(datos);
        this.totalSales = datos['numero_pedidos'];
        this.totalValue = datos['total_ventas'];
        if (this.totalValue !== 0 && this.totalSales !== 0) {
          this.averageSales = (this.totalValue / this.totalSales).toFixed(2);
        } else {
          this.averageSales = '0';
        }
        this.totalValue = this.totalValue.toFixed(2);
        this.topSales = datos['ventas_puestos'];
      }),
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-th', 'breadcrumb-title.dashboard sales'));
  }

  private setNoItemsConfig() {
    return {
      description: 'dashboard-page.selected centers not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

}
